import React from 'react';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import './seatingArrangementsModal.less';

interface SeatingArrangementsModalProps {
  open: boolean;
  onClose: () => void;
}

const SeatingArrangementsModal: React.FC<SeatingArrangementsModalProps> = ({
  open,
  onClose,
}) => {
  const { sportsAndEvents: t_sportsAndEvents } = useSelector(
    (data: RootState) => data.config.translations
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="90vw"
      style={{ maxWidth: '1200px', top: 20 }}
      className="seating-arrangements-modal"
      title={t_sportsAndEvents?.seatingArrangements}
    >
      <div className="seating-arrangements-content">
        <h2>{t_sportsAndEvents?.whereWillISit}</h2>

        <section>
          <h3>{t_sportsAndEvents?.seatingInPairs}</h3>
          <p>{t_sportsAndEvents?.seatingInPairsDescription}</p>
          <p className="note">{t_sportsAndEvents?.seatingInPairsNote}</p>
        </section>

        <section>
          <h3>{t_sportsAndEvents?.seatingThreeTogether}</h3>
          <p>{t_sportsAndEvents?.seatingThreeTogetherDescription}</p>
          <p className="note">
            {t_sportsAndEvents?.seatingThreeTogetherNote}
          </p>
        </section>

        <section>
          <h3>{t_sportsAndEvents?.homeFansOrAwayFans}</h3>
          <p>{t_sportsAndEvents?.homeFansDescription}</p>
          <p>{t_sportsAndEvents?.homeFansBehaviorCode}</p>
          <p className="note">{t_sportsAndEvents?.neutralVenueNote}</p>
        </section>

        <section>
          <h3>{t_sportsAndEvents?.singleTickets}</h3>
          <p>{t_sportsAndEvents?.singleTicketsDescription}</p>
          <p className="note">{t_sportsAndEvents?.singleTicketsNote}</p>
        </section>

        <section>
          <h3>{t_sportsAndEvents?.groupSeating}</h3>
          <p>{t_sportsAndEvents?.groupSeatingDescription}</p>
          <p className="note">{t_sportsAndEvents?.groupSeatingNote}</p>
        </section>

        <section>
          <h3>{t_sportsAndEvents?.pleaseNote}</h3>
          <p>{t_sportsAndEvents?.pleaseNoteDescription}</p>
          <p>{t_sportsAndEvents?.pleaseNoteConsult}</p>
        </section>

        <section className="contact-section">
          <h3>{t_sportsAndEvents?.haveMoreQuestions}</h3>
          <p>{t_sportsAndEvents?.contactUsForInfo}</p>
        </section>
      </div>
    </Modal>
  );
};

export default SeatingArrangementsModal;

